/* eslint-disable */


/**
 * Create styles for `<NotificationConfigs />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<NotificationConfigs />` styles
 */
const notificationConfigsStyles = ({ theme }) => ({
  configsHeading: {
    minWidth: theme.spacing(1) * 7,
    textAlign: `center`,
  },
  spinner: {
    height: theme.spacing(1) * 3,
  },
  topButton: {
    position: `absolute`,
    top: theme.spacing(1) * 2,
    right: theme.spacing(1) * 3,
  }
});

export default notificationConfigsStyles;
